export default __webpack_public_path__ + "static/media/rithmic.b12c58bc.png";